import React, { Fragment } from "react"
import { createRoot } from "react-dom/client"
import { PersistGate } from "redux-persist/integration/react"
import { Provider } from "react-redux"
import { ToastContainer } from "react-toastify"
import { RouterProvider } from "react-router-dom"

import router from "routes/index.routes"
import { store, persistor } from "@redux"
import * as serviceWorker from "./serviceWorker"

import "leaflet/dist/leaflet.css"
import "react-toastify/dist/ReactToastify.css"
import "cropperjs/dist/cropper.css"
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import "./index.scss"

const App = () => (
  <Fragment>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RouterProvider router={router} />
      </PersistGate>
    </Provider>
    <ToastContainer rtl />
  </Fragment>
)


const root = createRoot(
  document.getElementById("root")
)

root.render(<App />)

serviceWorker.unregister()